import { render, staticRenderFns } from "./popup-area.vue?vue&type=template&id=0836a49e&scoped=true"
import script from "./popup-area.vue?vue&type=script&lang=js"
export * from "./popup-area.vue?vue&type=script&lang=js"
import style0 from "./popup-area.vue?vue&type=style&index=0&id=0836a49e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836a49e",
  null
  
)

export default component.exports